export default "__VITE_ASSET__aJff85uw__"